import React, {useEffect, useState} from 'react';
import EyeInTheSky from "./EyeInTheSky";
import {getSessionFacts} from "../Session/sessionFacts";
import {getParams} from "../lib/params";
import {resetLocalStorageCache} from "../Session/cachedLocalStorage";

export default function EyeInTheSkyStartupWrapper(props) {

  const [sessionFacts, setSessionFacts] = useState(null);

  useEffect(() => {
    const params = getParams();

    if (params['RESET']) {
      resetLocalStorageCache();
    }

    let sf = getSessionFacts({params});

    setSessionFacts(sf);
  }, [])

  // Render it ONLY when session facts are fully loaded
  if (sessionFacts) {
    return <EyeInTheSky {...props} sessionFacts={sessionFacts} />;
  }

  return null;
}
